import React, {Component} from "react";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {SubmitButton} from "../buttons/SubmitButton";
import { withTranslation } from 'react-i18next';

class AgencyModuleManageAccountsInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            savingChanges: false,
            info: null
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    getData() {
        new APIClient(API_URL + 'agency/manage_accounts/').call('GET').then((response) => {
            if (response.status !== 'OK') {
                if (response['status'] === "AGENCY_NOT_SUBSCRIBED_TO_MODULE")
                {
                    this.setState({
                        info: {hasThisModuleInSuscription: false}
                    });
                    return;
                }
                alert(response['error_message']);
            } else {
                this.setState({
                    info: {
                        agencyId: response.data.agency_id,
                        agencyName: response.data.agency_name,
                        hasThisModuleInSuscription: response.data.has_this_module_in_suscription,
                        googleManagersId: response.data.google_managers_id,
                        facebookManagersId: response.data.facebook_manager_id,
                        webhookInfoIntervalInMinutes: response.data.webhook_info_interval_in_minutes,
                        googleChatWebhook: response.data.google_chat_webhook,
                        slackWebhook: response.data.slack_webhook,

                    }
                });
            }
        })
    }

    componentDidMount() {
        this.getData();
    }

    _editUrl() {
        return API_URL + 'agency/manage_accounts/';
    }

    handleSubmit() {
        const { t } = this.props;
        this.setState({savingChanges: true});
        new APIClient(this._editUrl()).call('POST', {
            'google_managers_ids': this.state.info.googleManagersId,
            'webhook_info_interval_in_minutes': this.state.info.webhookInfoIntervalInMinutes,
            'google_chat_webhook': this.state.info.googleChatWebhook,
            'slack_webhook': this.state.info.slackWebhook
        }).then((data) => {
            this.setState({savingChanges: false});
            let errors = [];
            if (data.status === 'ERROR') {
                errors = JSON.parse(data.errors);
            } else if (data.status === 'OK') {
                alert(t('agency_module_manage_accounts.changes_saved_successfully'));
            }
            this.setState({
                info: {
                    ...this.state.info,
                    errors: errors
                }
            });
        });
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;

        this.setState({
            info: {
                ...this.state.info,
                [name]: target.value
            }
        });
    }

    renderSaveButton() {
        const { t } = this.props;
        if (this.state.savingChanges) {
            return <Spinner color="positive small"/>;
        } else {
            return <SubmitButton onClick={this.handleSubmit} value={t('agency_module_manage_accounts.save_button')}/>;
        }
    }

    renderWebhookInfoIntervalInMinutesOptions() {
        const { t } = this.props;
        const options = [
            {'text': t('agency_module_manage_accounts.one_day'), 'value': 60*24},
            {'text': t('agency_module_manage_accounts.one_hour'), 'value': 60},
            {'text': t('agency_module_manage_accounts.twenty_minutes'), 'value': 20},
            {'text': t('agency_module_manage_accounts.ten_minutes'), 'value': 10}];

        return options.map(option =>
            (<option key={option.value} value={option.value}>
                {option.text}
            </option>)
        );
    }

    renderInfo() {
        const { t } = this.props;
        if (this.state.info !== null) {
            return (
                <div className="box">
                    <header className="box-header">
                        <h2 className="box-title">{t('agency_module_manage_accounts.module_title')}</h2>
                    </header>
                    <div className="form-row">
                        <div className="form-col">
                            <label>{t('agency_module_manage_accounts.mcc_ids_label')}</label>
                            <input onChange={this.handleChange} name="googleManagersId" type="text" value={this.state.info.googleManagersId}/>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-col">
                            <label>{t('agency_module_manage_accounts.send_info_interval_label')}</label>
                            <select onChange={this.handleChange} name="webhookInfoIntervalInMinutes" value={this.state.info.webhookInfoIntervalInMinutes}>
                                {this.renderWebhookInfoIntervalInMinutesOptions()}
                            </select>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-col">
                            <label>{t('agency_module_manage_accounts.google_chat_webhook_label')}</label>
                            <input onChange={this.handleChange} name="googleChatWebhook" type="text" value={this.state.info.googleChatWebhook}/>
                        </div>
                        <div className="form-col">
                            <label>{t('agency_module_manage_accounts.slack_webhook_label')}</label>
                            <input onChange={this.handleChange} name="slackWebhook" type="text" value={this.state.info.slackWebhook}/>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    render() {
        if(!this.state.info || !this.state.info.hasThisModuleInSuscription)
            return "";

        return (
            <form className="section-body-item -wide">
                {this.renderInfo()}
                <div className="submit-row">
                    {this.renderSaveButton()}
                </div>
            </form>
        )
    }
}

export default withTranslation()(AgencyModuleManageAccountsInfo);
